<template>
  <div class="process">
    <v-row>
      <v-col cols="10">
        <p class="text-h6">コース説明</p>
      </v-col>
      <v-col cols="2" style="display:flex;justify-content:flex-end;">
        <p>
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-icon color="blue" v-bind="attrs" v-on="on" style="margin-left:10px">
                mdi-help-circle
              </v-icon>
            </template>
            <span>タブを選択しコースをご確認ください。<br/>コース別参加者数は1時間に1回更新されます。<br/>(9時から21時)</span>
          </v-tooltip>
        </p>
      </v-col>
    </v-row>
    <v-row v-if="campaign.is_app_challenge">
      <v-col>
        <div class="rounded-pill py-2 px-5 mb-4 info--text" align="center" style="border: solid 3px">
          <b>食事バッチリ！アプリチャレンジコースの概要は <a href="https://youtu.be/katIV5-sG0I" target="_blank" class="info--text">こちら</a> </b>
        </div>
      </v-col>
    </v-row>
    <div v-if="courseList.length > 0">
      <v-sheet elevation="1">
        <v-tabs
          class="kenchare-tab"
          v-model="tabs"
          background-color="primary"
          fixed-tabs
          dark
          icons-and-text
          slider-size="10"
          show-arrows
        >
          <v-tabs-slider color="yellow"></v-tabs-slider>
          <v-tab v-for="course in courseList" :key="course.category.name">
            <p>{{ course.category.name }}</p>
          </v-tab>
        </v-tabs>

        <v-tabs-items v-model="tabs">
          <v-tab-item
            v-for="(course, index) in courseList"
            :key="index"
          >
            <v-container fluid>
              <v-row dense>
                <v-col
                  v-for="course in course.course"
                  :key="course.id"
                  cols="12"
                  sm="6"
                  md="4"
                >
                  <CourseDetailCard :course="course" />
                </v-col>
              </v-row>
            </v-container>
          </v-tab-item>
        </v-tabs-items>
      </v-sheet>
    </div>
  </div>
</template>

<script>
import GraphqlAPI from '../../utils/GraphqlAPI'
const CourseDetailCard = () => import('../course/CourseDetailCard')

const listCourseCategoryQuery = (campaignId) => `
  query listCourseCategory {
    listCourseCategory(campaign_id: "${campaignId}") {
      course_category {
        id
        meta
        name
      }
    }
  }
`

const getlistCourseCategory = async (campaignId) => {
  const { data: { listCourseCategory: data } } = await GraphqlAPI(listCourseCategoryQuery(campaignId))
  return {
    category: data.course_category.map((item) => {
      return {
        sort: item.meta,
        name: item.name
      }
    })
  }
}

const listCourseQuery = (campaignId) => `
  query getListCourse {
    listCourse(campaign_id: "${campaignId}") {
      courses {
        id
        name
        category
        objective
        basic_item
        recording_method
        precautionary_statement
        detailed_document_file_name
        youtube_url
        youtube_thumbnail_file_name
        participants
      }
    }
  }
`

const getListCourse = async (campaignId) => {
  const { data: { listCourse: data } } = await GraphqlAPI(listCourseQuery(campaignId))
  return data
}

export default {
  name: 'process_course',
  data () {
    return {
      tabs: null,
      courseCategoryList: [],
      courseList: []
    }
  },
  components: { CourseDetailCard },
  computed: {
    campaign () {
      return this.$store.getters.getCampaign
    }
  },
  async mounted () {
    // コース情報の取得
    const getlistCourseCategoryList = getlistCourseCategory(this.campaign.id)
    const getListCourseList = getListCourse(this.campaign.id)
    const me = this
    Promise.all([getlistCourseCategoryList, getListCourseList])
      .then(function (responce) {
        me.courseCategoryList = responce[0].category
        responce[1].courses.forEach(course => {
          const parent = me.courseCategoryList.find(category => {
            return course.category === category.sort
          })
          const targetCourseList = me.courseList.find(course => { return course.category.sort === parent.sort })
          if (typeof targetCourseList === 'undefined') {
            const courseList = []
            courseList.push(course)
            me.courseList.push({
              category: parent,
              course: courseList
            })
          } else {
            targetCourseList.course.push(course)
          }
        })
      }).catch(function (e) {
        me.$emit('errorHandling', 'コース情報の取得に失敗しました。' + e.errors[0].message)
        me.$log.debug(e)
      })
  }
}
</script>

<style scoped lang="scss">
.how-to-join-card {
  display: flex !important;
  flex-direction: column;
}
.how-to-join-text {
  flex-grow: 1;
  overflow: auto;
  font-size: 0.9rem;
}
</style>
